import { redirectTarget } from './redirectTarget'

window.location.replace(redirectTarget(window.location.pathname))
